// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function KassaTilesMobile(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Ломбарды",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-pawn-shop h-27.5"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Службы доставки",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-glovo h-54.5"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Магазины",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-store h-40"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Гики",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-geeks h-40"
          })
        ],
        className: "w-40 sm:w-60"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Кофейни и рестораны",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-restaurant h-54.5"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "СТО",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-shop h-40"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Такси",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-indriver h-27.5"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("span", {
              children: "Барбершопы",
              className: "caption text-white backdrop-blur-80 bg-white/12 py-1 px-3 rounded-bl rounded-tr"
            }),
            className: "rounded-sm flex justify-start items-end bg-cover bg-center mt-2 first:mt-0 bg-barber h-27.5"
          })
        ],
        className: "w-40 sm:w-60"
      }),
      JsxRuntime.jsx("div", {
        className: "h-111.25 w-full absolute bottom-0 bg-kassa-tiles"
      })
    ],
    className: "flex m-auto mt-10 justify-between sm:justify-around relative"
  });
}

const make = KassaTilesMobile;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
